// import React, { useEffect, useState } from 'react';
// import {
//   Box,
//   Typography,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   TextField,
//   LinearProgress,
//   MenuItem,
// } from '@mui/material';
// import api from '../../../api/axiosInterceptor';
// import { API_BASE_URL } from '../../../config';
// import TableComponent from '../../../Components/TableComponent/TableComponent';
// import { LoadingSpinner } from '../../../Components/spinner/spinner';
// import { SnackBarComponent } from '../../../Components/snackBar/snackBar';

// const sampleHeaders = [
//   "name",
//   "date_of_birth",
//   "father_name",
//   "cust_id",
//   "ph_number",
//   "adhaar_no",
//   "pan_no",
//   "email",
//   "bank_account_no",
//   "bank_name",
//   "bank_branch_name"
// ];

// export const AdminLegecyMasterComponent = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Dropdown list for FE Base
//   const [feBaseList, setFeBaseList] = useState([]);

//   // Selected FE Base name filter
//   const [selectedFeName, setSelectedFeName] = useState('');

//   // Snackbar state
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   // Upload dialog state
//   const [openUploadDialog, setOpenUploadDialog] = useState(false);
//   const [uploadingFile, setUploadingFile] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState(0);
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [financialEstablishment, setFinancialEstablishment] = useState('');

//   // Sample data format dialog
//   const [openSampleDataDialog, setOpenSampleDataDialog] = useState(false);

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
//     { id: 'financial_establishment', field: 'financial_establishment', headerName: 'FE Base', width: 200 },
//     { id: 'name', field: 'name', headerName: 'Name', width: 150 },
//     { id: 'date_of_birth', field: 'date_of_birth', headerName: 'Date of Birth', width: 120 },
//     { id: 'father_name', field: 'father_name', headerName: 'Father Name', width: 150 },
//     { id: 'cust_id', field: 'cust_id', headerName: 'Cust ID', width: 150 },
//     { id: 'ph_number', field: 'ph_number', headerName: 'Phone Number', width: 130 },
//     { id: 'adhaar_no', field: 'adhaar_no', headerName: 'Adhaar No', width: 150 },
//     { id: 'pan_no', field: 'pan_no', headerName: 'PAN No', width: 150 },
//     { id: 'email', field: 'email', headerName: 'Email', width: 200 },
//     { id: 'bank_account_no', field: 'bank_account_no', headerName: 'Bank Account No', width: 170 },
//     { id: 'bank_name', field: 'bank_name', headerName: 'Bank Name', width: 150 },
//     { id: 'bank_branch_name', field: 'bank_branch_name', headerName: 'Bank Branch', width: 150 },
//   ];

//   useEffect(() => {
//     fetchFeBaseList();
//   }, []);

//   // Refetch legacy records each time selectedFeName changes
//   useEffect(() => {
//     fetchLegecyRecords(selectedFeName);
//   }, [selectedFeName]);

//   const fetchFeBaseList = () => {
//     api.get(`${API_BASE_URL}/fe-mgmt/fe-base/`)
//       .then(res => setFeBaseList(res.data || []))
//       .catch(() => setFeBaseList([]));
//   };

//   // Fetch records filtered by fe_name via URL path param
//   const fetchLegecyRecords = (feName = '') => {
//     setLoading(true);
//     let url = `${API_BASE_URL}/fe-mgmt/legecy/`;
//     if (feName) {
//       // use encoded feName in path
//       url += encodeURIComponent(feName) + '/';
//     }
//     api.get(url)
//       .then(res => {
//         const apiData = res.data.map((item, index) => ({
//           id: item.id,
//           slNo: index + 1,
//           financial_establishment: item.financial_establishment?.name_of_fe || item.financial_establishment,
//           ...item,
//         }));
//         setRows(apiData);
//         setLoading(false);
//       })
//       .catch(() => {
//         setSnackbarMessage('Failed to load legacy records.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   };

//   const handleSnackbarClose = () => setSnackbarOpen(false);

//   const handleFileChange = (e) => {
//     if (e.target.files.length > 0) setSelectedFile(e.target.files[0]);
//   };

//   const handleUploadSubmit = async () => {
//     if (!selectedFile) {
//       setSnackbarMessage('Please select a file.');
//       setSnackbarSeverity('warning');
//       setSnackbarOpen(true);
//       return;
//     }
//     if (!financialEstablishment) {
//       setSnackbarMessage('Please select Financial Establishment.');
//       setSnackbarSeverity('warning');
//       setSnackbarOpen(true);
//       return;
//     }
//     const validExtensions = ['.xls', '.xlsx'];
//     if (!validExtensions.some(ext => selectedFile.name.toLowerCase().endsWith(ext))) {
//       setSnackbarMessage('Invalid file format. Please upload an Excel file (.xls or .xlsx).');
//       setSnackbarSeverity('warning');
//       setSnackbarOpen(true);
//       return;
//     }
//     const formDataUpload = new FormData();
//     formDataUpload.append('legecy_data', selectedFile);
//     formDataUpload.append('financial_establishment', financialEstablishment);
//     try {
//       setUploadingFile(true);
//       await api.post(`${API_BASE_URL}/fe-mgmt/legecy/`, formDataUpload, {
//         headers: { 'Content-Type': 'multipart/form-data' },
//         onUploadProgress: e => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
//       });
//       setSnackbarMessage('File uploaded and data saved successfully.');
//       setSnackbarSeverity('success');
//       setSnackbarOpen(true);
//       setOpenUploadDialog(false);
//       // refresh with current feName if available
//       if (financialEstablishment) {
//         const feName = feBaseList.find(fe => fe.id === financialEstablishment)?.name_of_fe || '';
//         setSelectedFeName(feName);
//       } else {
//         fetchLegecyRecords();
//       }
//       setSelectedFile(null);
//       setFinancialEstablishment('');
//     } catch (error) {
//       setSnackbarMessage(error?.response?.data?.error || 'Failed to upload file.');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     } finally {
//       setUploadingFile(false);
//       setUploadProgress(0);
//     }
//   };

//   return (
//     <Box sx={{ width: '100%', mt: 8, mb: 1, borderRadius: 2, boxShadow: '0 4px 12px rgba(0,0,0,0.1)', bgcolor: '#fff' }}>
//       <Box display="flex" justifyContent="start" gap={2} alignItems="center" bgcolor="rgba(195,234,203,0.1)" p={2}>
//         <Typography variant="h6" fontWeight="bold">Filter By FE Base:</Typography>
//         <TextField
//           select
//           size="small"
//           sx={{ minWidth: 280 }}
//           value={selectedFeName}
//           onChange={e => setSelectedFeName(e.target.value)}
//           label="Select FE Base"
//         >
//           <MenuItem value="">All</MenuItem>
//           {feBaseList.map(fe => (
//             <MenuItem key={fe.id} value={fe.name_of_fe}>
//               {fe.name_of_fe}
//             </MenuItem>
//           ))}
//         </TextField>
//       </Box>

//       <Box display="flex" justifyContent="flex-end" p={2}>
//         <Button variant="outlined" color="primary" onClick={() => setOpenUploadDialog(true)}>Upload Excel</Button>
//       </Box>

//       {loading ? (
//         <LoadingSpinner size={30} />
//       ) : (
//         <TableComponent columns={columns} rows={rows} manageColumnStatus enableSort sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }} />
//       )}

//       {/* Upload Excel Dialog */}
//       <Dialog open={openUploadDialog} onClose={() => !uploadingFile && setOpenUploadDialog(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>Upload Legacy Excel File</DialogTitle>
//         <DialogContent>
//           <Box display="flex" gap={1} alignItems="center" mb={1}>
//             <TextField
//               select
//               label="Financial Establishment"
//               fullWidth
//               value={financialEstablishment}
//               onChange={e => setFinancialEstablishment(e.target.value)}
//               disabled={uploadingFile}
//             >
//               {feBaseList.map(fe => (
//                 <MenuItem key={fe.id} value={fe.id}>
//                   {fe.name_of_fe || fe.id}
//                 </MenuItem>
//               ))}
//             </TextField>
//             <Button size="small" variant="outlined" onClick={() => setOpenSampleDataDialog(true)} disabled={uploadingFile}>
//               View Sample Data
//             </Button>
//           </Box>

//           <Button variant="outlined" component="label" fullWidth>
//             {selectedFile ? selectedFile.name : 'Select Excel File'}
//             <input type="file" hidden accept=".xls,.xlsx" onChange={handleFileChange} disabled={uploadingFile} />
//           </Button>

//           {uploadingFile && (
//             <Box sx={{ mt: 2 }}>
//               <LinearProgress variant="determinate" value={uploadProgress} />
//               <Typography variant="body2" sx={{ textAlign: 'center', mt: 1 }}>
//                 {uploadProgress}%
//               </Typography>
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => !uploadingFile && setOpenUploadDialog(false)} disabled={uploadingFile}>Cancel</Button>
//           <Button onClick={handleUploadSubmit} variant="contained" disabled={uploadingFile}>Upload</Button>
//         </DialogActions>
//       </Dialog>

//       {/* Sample Data Format Modal */}
//       <Dialog open={openSampleDataDialog} onClose={() => setOpenSampleDataDialog(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>Sample Data Format Headers</DialogTitle>
//         <DialogContent dividers>
//           <Typography component="pre" sx={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}>
//             {sampleHeaders.join('\n')}
//           </Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenSampleDataDialog(false)}>Close</Button>
//         </DialogActions>
//       </Dialog>

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />
//     </Box>
//   );
// };


import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  LinearProgress,
  MenuItem,
} from '@mui/material';
import api from '../../../api/axiosInterceptor';
import { API_BASE_URL } from '../../../config';
import TableComponent from '../../../Components/TableComponent/TableComponent';
import { LoadingSpinner } from '../../../Components/spinner/spinner';
import { SnackBarComponent } from '../../../Components/snackBar/snackBar';

const sampleHeaders = [
  "name",
  "date_of_birth",
  "father_name",
  "cust_id",
  "ph_number",
  "adhaar_no",
  "pan_no",
  "email",
  "bank_account_no",
  "bank_name",
  "bank_branch_name",
  "total_deposite",
  "total_loan",
  "total_witdrown",
  "total_claim"
];

export const AdminLegecyMasterComponent = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  // Dropdown list for FE Base
  const [feBaseList, setFeBaseList] = useState([]);

  // Selected FE Base name filter
  const [selectedFeName, setSelectedFeName] = useState('');

  // Snackbar state
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  // Upload dialog state
  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [uploadingFile, setUploadingFile] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);
  const [financialEstablishment, setFinancialEstablishment] = useState('');

  // Sample data format dialog
  const [openSampleDataDialog, setOpenSampleDataDialog] = useState(false);

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
    { id: 'financial_establishment', field: 'financial_establishment', headerName: 'FE Base', width: 200 },
    { id: 'name', field: 'name', headerName: 'Name', width: 150 },
    { id: 'date_of_birth', field: 'date_of_birth', headerName: 'Date of Birth', width: 120 },
    { id: 'father_name', field: 'father_name', headerName: 'Father Name', width: 150 },
    { id: 'cust_id', field: 'cust_id', headerName: 'Cust ID', width: 150 },
    { id: 'ph_number', field: 'ph_number', headerName: 'Phone Number', width: 130 },
    { id: 'adhaar_no', field: 'adhaar_no', headerName: 'Adhaar No', width: 150 },
    { id: 'pan_no', field: 'pan_no', headerName: 'PAN No', width: 150 },
    { id: 'email', field: 'email', headerName: 'Email', width: 200 },
    { id: 'bank_account_no', field: 'bank_account_no', headerName: 'Bank Account No', width: 170 },
    { id: 'bank_name', field: 'bank_name', headerName: 'Bank Name', width: 150 },
    { id: 'bank_branch_name', field: 'bank_branch_name', headerName: 'Bank Branch', width: 150 },
    { id: 'total_deposite', field: 'total_deposite', headerName: 'Total Deposit', width: 150 },
    { id: 'total_loan', field: 'total_loan', headerName: 'Total Loan', width: 150 },
    { id: 'total_witdrown', field: 'total_witdrown', headerName: 'Total Withdrawn', width: 150 },
    { id: 'total_claim', field: 'total_claim', headerName: 'Total Claim', width: 150 },
  ];

  useEffect(() => {
    fetchFeBaseList();
  }, []);

  // Refetch legacy records each time selectedFeName changes
  useEffect(() => {
    fetchLegecyRecords(selectedFeName);
  }, [selectedFeName]);

  const fetchFeBaseList = () => {
    api.get(`/fe-mgmt/fe-base/`)
      .then(res => setFeBaseList(res.data || []))
      .catch(() => setFeBaseList([]));
  };

  // Fetch records filtered by fe_name via URL path param
  const fetchLegecyRecords = (feName = '') => {
    setLoading(true);
    let url = `/fe-mgmt/legecy/`;
    if (feName) {
      // use encoded feName in path
      url += encodeURIComponent(feName) + '/';
    }
    api.get(url)
      .then(res => {
        const apiData = res.data.map((item, index) => ({
          id: item.id,
          slNo: index + 1,
          financial_establishment: item.financial_establishment?.name_of_fe || item.financial_establishment,
          ...item,
        }));
        setRows(apiData);
        setLoading(false);
      })
      .catch(() => {
        setSnackbarMessage('Failed to load legacy records.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleFileChange = (e) => {
    if (e.target.files.length > 0) setSelectedFile(e.target.files[0]);
  };

  const handleUploadSubmit = async () => {
    if (!selectedFile) {
      setSnackbarMessage('Please select a file.');
      setSnackbarSeverity('warning');
      setSnackbarOpen(true);
      return;
    }
    if (!financialEstablishment) {
      setSnackbarMessage('Please select Financial Establishment.');
      setSnackbarSeverity('warning');
      setSnackbarOpen(true);
      return;
    }
    const validExtensions = ['.xls', '.xlsx'];
    if (!validExtensions.some(ext => selectedFile.name.toLowerCase().endsWith(ext))) {
      setSnackbarMessage('Invalid file format. Please upload an Excel file (.xls or .xlsx).');
      setSnackbarSeverity('warning');
      setSnackbarOpen(true);
      return;
    }
    const formDataUpload = new FormData();
    formDataUpload.append('legecy_data', selectedFile);
    formDataUpload.append('financial_establishment', financialEstablishment);
    try {
      setUploadingFile(true);
      await api.post(`/fe-mgmt/legecy/`, formDataUpload, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: e => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
      });
      setSnackbarMessage('File uploaded and data saved successfully.');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      setOpenUploadDialog(false);
      // refresh with current feName if available
      if (financialEstablishment) {
        const feName = feBaseList.find(fe => fe.id === financialEstablishment)?.name_of_fe || '';
        setSelectedFeName(feName);
      } else {
        fetchLegecyRecords();
      }
      setSelectedFile(null);
      setFinancialEstablishment('');
    } catch (error) {
      setSnackbarMessage(error?.response?.data?.error || 'Failed to upload file.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setUploadingFile(false);
      setUploadProgress(0);
    }
  };

  return (
    <Box sx={{ width: '100%', mt: 8, mb: 1, borderRadius: 2, boxShadow: '0 4px 12px rgba(0,0,0,0.1)', bgcolor: '#fff' }}>
      <Box display="flex" justifyContent="start" gap={2} alignItems="center" bgcolor="rgba(195,234,203,0.1)" p={2}>
        <Typography variant="h6" fontWeight="bold">Filter By FE Base:</Typography>
        <TextField
          select
          size="small"
          sx={{ minWidth: 280 }}
          value={selectedFeName}
          onChange={e => setSelectedFeName(e.target.value)}
          label="Select FE Base"
        >
          <MenuItem value="">All</MenuItem>
          {feBaseList.map(fe => (
            <MenuItem key={fe.id} value={fe.name_of_fe}>
              {fe.name_of_fe}
            </MenuItem>
          ))}
        </TextField>
      </Box>

      <Box display="flex" justifyContent="flex-end" p={2}>
        <Button variant="outlined" color="primary" onClick={() => setOpenUploadDialog(true)}>Upload Excel</Button>
      </Box>

      {loading ? (
        <LoadingSpinner size={30} />
      ) : (
        <TableComponent
          columns={columns}
          rows={rows}
          manageColumnStatus
          enableSort
          sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
        />
      )}

      {/* Upload Excel Dialog */}
      <Dialog open={openUploadDialog} onClose={() => !uploadingFile && setOpenUploadDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Upload Legacy Excel File</DialogTitle>
        <DialogContent>
          <Box display="flex" gap={1} alignItems="center" mb={1}>
            <TextField
              select
              label="Financial Establishment"
              fullWidth
              value={financialEstablishment}
              onChange={e => setFinancialEstablishment(e.target.value)}
              disabled={uploadingFile}
            >
              {feBaseList.map(fe => (
                <MenuItem key={fe.id} value={fe.id}>
                  {fe.name_of_fe || fe.id}
                </MenuItem>
              ))}
            </TextField>
            <Button size="small" variant="outlined" onClick={() => setOpenSampleDataDialog(true)} disabled={uploadingFile}>
              View Sample Data
            </Button>
          </Box>

          <Button variant="outlined" component="label" fullWidth>
            {selectedFile ? selectedFile.name : 'Select Excel File'}
            <input type="file" hidden accept=".xls,.xlsx" onChange={handleFileChange} disabled={uploadingFile} />
          </Button>

          {uploadingFile && (
            <Box sx={{ mt: 2 }}>
              <LinearProgress variant="determinate" value={uploadProgress} />
              <Typography variant="body2" sx={{ textAlign: 'center', mt: 1 }}>
                {uploadProgress}%
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => !uploadingFile && setOpenUploadDialog(false)} disabled={uploadingFile}>Cancel</Button>
          <Button onClick={handleUploadSubmit} variant="contained" disabled={uploadingFile}>Upload</Button>
        </DialogActions>
      </Dialog>

      {/* Sample Data Format Modal */}
      <Dialog open={openSampleDataDialog} onClose={() => setOpenSampleDataDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Sample Data Format Headers</DialogTitle>
        <DialogContent dividers>
          <Typography component="pre" sx={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}>
            {sampleHeaders.join('\n')}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenSampleDataDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};

